module.exports = __webpack_public_path__ + "fonts/butler_bold-webfont.f819a89.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/butler/butler_bold-webfont.woff2
// module id = 555
// module chunks = 0